import React from "react"
import Cabecalho from "../Cabecalho"
import { TabelaMensagensIzza } from "./components/TabelaMensagensIzza"

export function VerEnviosIzza() {
    return (
        <>
            <Cabecalho pagina="Mensagens Izza" />
            <TabelaMensagensIzza />
        </>
    )
}
